import { getRequest } from "../../../services/RestServices";
import { GET_VEHICLE_JOB_SUMMARY } from "../../api/C4S Decommission - Replacement/url";
import { GET_JOBS_Dropdown, GET_REVIEW_DETAILS } from "../../api/scheduler/url";

export const getDropDownData = async (so_Id) => {
  try {
    return await getRequest(`${GET_JOBS_Dropdown}/${so_Id}`);
  } catch (err) {
    return err;
  }
};

export const getReviewDetails = async (job_Id) => {
  try {
    return await getRequest(`${GET_REVIEW_DETAILS}/${job_Id}`);
  } catch (err) {
    return err;
  }
};

export const getJobSummaryData = async (job_Id) => {
  try {
    return await getRequest(`${GET_VEHICLE_JOB_SUMMARY}/${job_Id}/summary`);
  } catch (err) {
    return err;
  }
};
